<div class="theme-switch-container">
	<div
		class="theme-toggle-pill"
		[attr.data-active]="
			isLightActive() ? 'light' : isAutoActive() ? 'auto' : 'dark'
		"
	>
		<button
			class="theme-option light-option"
			[class.active]="isLightActive()"
			(click)="setThemeMode('light')"
			aria-label="Light mode"
		>
			<jepto-theme-mode-icon mode="light" />
		</button>
		<button
			class="theme-option auto-option"
			[class.active]="isAutoActive()"
			(click)="setThemeMode('auto')"
			aria-label="Auto mode (follow report configuration)"
		>
			<jepto-theme-mode-icon mode="auto" />
		</button>
		<button
			class="theme-option dark-option"
			[class.active]="isDarkActive()"
			(click)="setThemeMode('dark')"
			aria-label="Dark mode"
		>
			<jepto-theme-mode-icon mode="dark" />
		</button>
	</div>
</div>
